import { NotificationsModel } from "src/app/core/data/model/notifications-model";

export abstract class NotificationsState {}

export class LatestNotificationsReadyState extends NotificationsState {
    constructor(public notificationsList: NotificationsModel[]) {
      super();
    }
  }
  
export class LoadMoreNotificationsSucessState extends NotificationsState {
    constructor(public notificationsList: NotificationsModel[]) {
        super();
    }
}

export class MarkNotificationAsReadSucessState extends NotificationsState {
    constructor(public unseenNotificationCount: number, public notification: string) {
        super();
    }
}

export class GetUnseenNotificationsCountReadyState extends NotificationsState {
    constructor(public count: number) {
        super();
    }
}